import React from 'react';

import cs from 'classnames';
import {Link} from 'react-router';
import styled from 'styled-components';

import type {ToastMessageLinkType} from 'app/toasts/slice';

const iconsMap = {
  warning: 'fas fa-exclamation-circle',
  error: 'far fa-exclamation-triangle',
  success: 'fas fa-check',
} as const;

interface Props {
  children: string;
  link?: ToastMessageLinkType;
  level: string;
  messageId: string | number;
  onClose: (messageId: string | number) => unknown;
}

export const ToastNotification = ({
  children,
  link,
  level,
  onClose,
  messageId,
}: Props) => {
  const theme = level.replace('error', 'danger');

  return (
    <StyledNotificationDiv
      className={`mb-0 mt-2 d-flex justify-content-between border-${theme}`}
    >
      <div className="content-wrapper flex-grow-1 flex-shrink-1 px-2 d-flex justify-content-between">
        <div className="content flex-grow-1 d-flex my-2 p-1 pr-2 align-items-center">
          {level != null && level !== 'info' ? (
            <i className={cs('mr-2', `text-${theme}`, iconsMap[level])} />
          ) : null}
          <div className="flex-grow-1">{children}</div>
        </div>
        {link != null ? (
          <div className="actions d-flex align-items-center">
            <Link
              className="text-nowrap"
              onClick={() => onClose(messageId)}
              to={link.to}
            >
              {link.text}
            </Link>
          </div>
        ) : null}
      </div>
      <button
        onClick={() => onClose(messageId)}
        type="button"
        className="btn btn-sm px-3 flex-grow-0 flex-shrink-0 text-secondary"
        data-dismiss="alert"
        aria-label="Close"
      >
        <i className="fa fa-times" />
      </button>
    </StyledNotificationDiv>
  );
};

const StyledNotificationDiv = styled.div`
  min-width: 30vw;
  background: #fff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
  border-left-width: 3px;
  border-left-style: solid;
  border-radius: 4px;

  @media (max-width: 992px) {
    width: 60vw;
  }

  @media (max-width: 768px) {
    width: 80vw;
  }

  @media (max-width: 575px) {
    width: 90vw;
  }

  > .content-wrapper {
    border-right: 1px solid #eee;
    font-size: 90%;

    .actions {
      letter-spacing: -0.25pt;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 90%;
    }
  }
`;
